export enum GameProvider {
  PG_SOFT = 'pgsoft',
  SPRIBE = 'spribe',
  B52 = 'b52',
  CQ9 = 'cq9',
  HIT_CLUB = 'hitclub',
  RIK_VIP = 'rikvip',
  PLAY_N_GO = 'playngo',
  TECHPLAY = 'techplay',
  SABA = 'saba',
  PRAGMATIC = 'pragmatic',
  NETENT = 'netent',
  RED_TIGER = 'redtiger',
  Q_TECH = 'qtech',
  JDB = 'jdb',
  HABANERO = 'habanero',
  EVOPLAY = 'evoplay'
}
